import styled from 'styled-components'
import { colors } from '@giphy/react-giphy-brand'
import routes from 'shared/routes'
import { Link } from 'react-router-dom'

export const Copy = styled.div`
    font-size: 14px;
    color: white;
    a {
        color: ${colors.giphyBlue};
    }
`

const Terms = styled(Copy)`
    font-size: 12px;
    margin: 10px 0;
`
export const TermsOfService = () => (
    <Terms>
        By signing up you agree to GIPHY&apos;s <a href="/terms">Terms of Service</a>
    </Terms>
)
export const TermsOfServiceLogin = () => (
    <Terms>
        By logging in you agree to GIPHY&apos;s <a href="/terms">Terms of Service</a>
    </Terms>
)

export const Login = () => (
    <Copy>
        Already have an account? <Link to={routes.LOGIN}>Log in</Link>
    </Copy>
)

export const Join = () => (
    <Copy>
        Don&apos;t Have An Account? <Link to={routes.JOIN}>Join GIPHY!</Link>
    </Copy>
)

export const ForgotPassword = () => (
    <Copy>
        <a href="/password/reset">Forgot Your Password?</a>
    </Copy>
)
